import React from 'react';
import { logInfo } from '../../../../utils/logger';

export const FileDropZone = ({ onFileDrop }) => {
  return (
    <div 
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onDrop={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const file = e.dataTransfer.files[0];
        if (file) {
          onFileDrop(file);
          logInfo('File dropped successfully');
        }
      }}
      className="absolute inset-0 pointer-events-none"
    />
  );
};